export function areArraysEqual(
  a: Array<number | string | boolean | object | null | undefined>,
  b: Array<number | string | boolean | object | null | undefined>
) {
  return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, index) => val === b[index]);
}

/**
 * Only for testing purposes
 */
export function duplicateArrayValue(data: any[], length = 5, uniqueKeyName = 'id', elementIndex = 0) {
  if (!Array.isArray(data) || data.length === 0) {
    return [];
  }

  const element = elementIndex >= 0 && data[elementIndex] !== undefined ? data[elementIndex] : data[0];
  length = isNaN(length) || length < 2 ? 5 : length;

  return Array.from({ length }, (_, i) => ({
    ...element,
    [uniqueKeyName]: `arr-duplicate-val-${i + 1}`,
  }));
}
